import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { uploadFileToS3 } from '../../utils/s3Operations';

export async function uploadImagesAndSaveRecords(
  formData,
  images,
  facilityId,
  uploaderId,
) {
  const db = getFirestore();
  const imageCollectionRef = collection(db, 'images');

  try {
    const fileUploads = await Promise.all(
      images.map(async (image) => {
        return await uploadFileToS3(image, 'images');
      }),
    );

    const recordPromises = fileUploads.map(({ url, key }) => {
      return addDoc(imageCollectionRef, {
        ...formData,
        imageUrl: url,
        s3Key: key,
        uploaded: Date.now(),
        facility: facilityId,
        uploaderId: uploaderId,
      });
    });

    await Promise.all(recordPromises);
    console.log('All data saved successfully');
  } catch (error) {
    console.error('Error saving data: ', error);
  }
}
